import React from "react";
import { Dialog, DialogTitle, DialogActions, Button } from "@mui/material";
import { useConfirmationModal } from "../../services/ConfirmationModalService";

const ConfirmationModal = () => {
  const { isOpen, title, closeModal, confirmAction } = useConfirmationModal();

  return (
    <Dialog open={isOpen} onClose={closeModal}>
      <DialogTitle sx={{ fontSize: "18px" }}>{title}</DialogTitle>
      <DialogActions>
        <Button onClick={closeModal} color="primary">
          No
        </Button>
        <Button onClick={confirmAction} color="secondary" autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;